function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19868"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59608",
    d: "m85.371 43.226-2.7 2.7-5.552 5.556-6.848 6.848-.012.016a.348.348 0 0 1-.044.036 1.678 1.678 0 0 1-1.04.452l-4.08.3a1.017 1.017 0 0 1-1.088-1.084l.3-4.084a1.682 1.682 0 0 1 .456-1.036.4.4 0 0 1 .04-.044l.012-.012 10.84-10.852 1.552-1.552 2.7-2.7z",
    transform: "translate(-40.003 -24.262)",
    style: {
      fill: "#fdd241"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59609",
    d: "m111.018 33.481-1.432-1.432a2.849 2.849 0 0 0-4.028 0l-1.788 1.788 5.46 5.46 1.788-1.788a2.849 2.849 0 0 0 0-4.028z",
    transform: "translate(-63.862 -20.329)",
    style: {
      fill: "#ff5178"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59610",
    d: "m28.3 33.7-.3 4.084a1.017 1.017 0 0 0 1.088 1.084l4.08-.3a1.678 1.678 0 0 0 1.04-.452.348.348 0 0 0 .044-.036l.012-.016 6.848-6.848v17.492A3.29 3.29 0 0 1 37.824 52H7.292A3.29 3.29 0 0 1 4 48.708V15.1L14.884 4h22.94a3.29 3.29 0 0 1 3.292 3.292v13l-1.464 1.468-10.844 10.848-.012.012a.4.4 0 0 0-.04.044A1.682 1.682 0 0 0 28.3 33.7z",
    transform: "translate(-4 -4)",
    style: {
      fill: "#eaeaea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59611",
    d: "M11.6 14.884H4L14.884 4v7.6a3.288 3.288 0 0 1-3.284 3.284z",
    transform: "translate(-4 -4)",
    style: {
      fill: "#bebebe"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19857"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59612",
    d: "m70.265 80.986-.016.014c-.016.012-.028.028-.044.04a1.7 1.7 0 0 1-1.036.452l-4.084.3A1.019 1.019 0 0 1 64 80.706l.3-4.084a1.672 1.672 0 0 1 .456-1.036.4.4 0 0 1 .04-.044l.012-.012z",
    transform: "translate(-39.997 -46.918)",
    style: {
      fill: "#ffcf96"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19856"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59614",
    d: "M42.264 52.53H24.82a.7.7 0 1 0 0 1.4h17.444a.7.7 0 0 0 0-1.4z",
    transform: "translate(-16.072 -33.118)",
    style: {
      fill: "#434343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59615",
    d: "M24.82 77h8.724a.7.7 0 1 0 0-1.4H24.82a.7.7 0 0 0 0 1.4z",
    transform: "translate(-16.072 -46.96)",
    style: {
      fill: "#434343"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon2);
export default __webpack_public_path__ + "static/media/delivery-icon2.3ae40f03a4fefb3cb6740a493ac1e892.svg";
export { ForwardRef as ReactComponent };